import { z } from "zod";
/**
 * Business Central Standard Entities
 */
export const Company = z
    .object({
    id: z.string(),
    systemVersion: z.string(),
    name: z.string(),
    displayName: z.string(),
    businessProfileId: z.string(),
    systemCreatedAt: z.string(),
    systemCreatedBy: z.string(),
    systemModifiedAt: z.string(),
    systemModifiedBy: z.string(),
})
    .meta({ ref: "Company" });
export const Customer = z
    .object({
    id: z.string(),
    number: z.string(),
    displayName: z.string(),
    type: z.string(),
    addressLine1: z.string(),
    addressLine2: z.string(),
    city: z.string(),
    state: z.string(),
    country: z.string(),
    postalCode: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
    website: z.string(),
    taxLiable: z.boolean(),
    taxAreaId: z.string(),
    taxAreaDisplayName: z.string(),
    taxRegistrationNumber: z.string(),
    currencyId: z.string(),
    currencyCode: z.string(),
    paymentTermsId: z.string(),
    shipmentMethodId: z.string(),
    paymentMethodId: z.string(),
    blocked: z.string(),
    lastModifiedDateTime: z.string(),
})
    .meta({ ref: "Customer" });
export const Dimension = z.object({
    id: z.string(),
    code: z.string(),
    displayName: z.string(),
    lastModifiedDateTime: z.string(),
});
export const DimensionValue = z.object({
    id: z.string(),
    code: z.string(),
    dimensionId: z.string(),
    displayName: z.string(),
    lastModifiedDateTime: z.string(),
});
export const Employee = z
    .object({
    id: z.string(),
    number: z.string(),
    displayName: z.string(),
    givenName: z.string(),
    middleName: z.string(),
    surname: z.string(),
    jobTitle: z.string(),
    addressLine1: z.string(),
    addressLine2: z.string(),
    city: z.string(),
    state: z.string(),
    country: z.string(),
    postalCode: z.string(),
    phoneNumber: z.string(),
    mobilePhone: z.string(),
    email: z.string(),
    personalEmail: z.string(),
    employmentDate: z.string(),
    terminationDate: z.string(),
    status: z.string(),
    birthDate: z.string(),
    statisticsGroupCode: z.string(),
    lastModifiedDateTime: z.string(),
})
    .meta({ ref: "Employee" });
export const PdfDocument = z
    .object({
    id: z.string(),
    parentId: z.string(),
    parentType: z.string(),
    pdfDocumentContent: z.string(),
})
    .meta({ ref: "PdfDocument" });
export const SalesCreditMemo = z
    .object({
    id: z.string(),
    number: z.string(),
    externalDocumentNumber: z.string(),
    creditMemoDate: z.string(),
    postingDate: z.string(),
    dueDate: z.string(),
    customerId: z.string(),
    customerNumber: z.string(),
    customerName: z.string(),
    billToName: z.string(),
    billToCustomerId: z.string(),
    billToCustomerNumber: z.string(),
    sellToAddressLine1: z.string(),
    sellToAddressLine2: z.string(),
    sellToCity: z.string(),
    sellToCountry: z.string(),
    sellToState: z.string(),
    sellToPostCode: z.string(),
    billToAddressLine1: z.string(),
    billToAddressLine2: z.string(),
    billToCity: z.string(),
    billToCountry: z.string(),
    billToState: z.string(),
    billToPostCode: z.string(),
    currencyId: z.string(),
    currencyCode: z.string(),
    paymentTermsId: z.string(),
    shipmentMethodId: z.string(),
    salesperson: z.string(),
    pricesIncludeTax: z.boolean(),
    discountAmount: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    totalAmountExcludingTax: z.number(),
    totalTaxAmount: z.number(),
    totalAmountIncludingTax: z.number(),
    status: z.string(),
    lastModifiedDateTime: z.string(),
    invoiceId: z.string(),
    invoiceNumber: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
})
    .meta({ ref: "SalesCreditMemo" });
export const SalesCreditMemoLine = z
    .object({
    id: z.string(),
    documentId: z.string(),
    sequence: z.number(),
    itemId: z.string(),
    accountId: z.string(),
    lineType: z.string(),
    lineObjectNumber: z.string(),
    description: z.string(),
    unitOfMeasureId: z.string(),
    unitOfMeasureCode: z.string(),
    unitPrice: z.number(),
    quantity: z.number(),
    discountAmount: z.number(),
    discountPercent: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    amountExcludingTax: z.number(),
    taxCode: z.string(),
    taxPercent: z.number(),
    totalTaxAmount: z.number(),
    amountIncludingTax: z.number(),
    invoiceDiscountAllocation: z.number(),
    netAmount: z.number(),
    netTaxAmount: z.number(),
    netAmountIncludingTax: z.number(),
    shipmentDate: z.string(),
    itemVariantId: z.string(),
})
    .meta({ ref: "SalesCreditMemoLine" });
export const SalesInvoice = z
    .object({
    id: z.string(),
    number: z.string(),
    externalDocumentNumber: z.string(),
    invoiceDate: z.string(),
    postingDate: z.string(),
    dueDate: z.string(),
    customerPurchaseOrderReference: z.string(),
    customerId: z.string(),
    customerNumber: z.string(),
    customerName: z.string(),
    billToName: z.string(),
    billToCustomerId: z.string(),
    billToCustomerNumber: z.string(),
    shipToName: z.string(),
    shipToContact: z.string(),
    sellToAddressLine1: z.string(),
    sellToAddressLine2: z.string(),
    sellToCity: z.string(),
    sellToCountry: z.string(),
    sellToState: z.string(),
    sellToPostCode: z.string(),
    billToAddressLine1: z.string(),
    billToAddressLine2: z.string(),
    billToCity: z.string(),
    billToCountry: z.string(),
    billToState: z.string(),
    billToPostCode: z.string(),
    shipToAddressLine1: z.string(),
    shipToAddressLine2: z.string(),
    shipToCity: z.string(),
    shipToCountry: z.string(),
    shipToState: z.string(),
    shipToPostCode: z.string(),
    currencyId: z.string(),
    currencyCode: z.string(),
    paymentTermsId: z.string(),
    shipmentMethodId: z.string(),
    paymentMethodId: z.string().optional(),
    salesperson: z.string(),
    pricesIncludeTax: z.boolean(),
    discountAmount: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    totalAmountExcludingTax: z.number(),
    totalTaxAmount: z.number(),
    totalAmountIncludingTax: z.number(),
    status: z.string(),
    lastModifiedDateTime: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
})
    .meta({ ref: "SalesInvoice" });
export const SalesInvoiceLine = z
    .object({
    id: z.string(),
    documentId: z.string(),
    sequence: z.number(),
    itemId: z.string(),
    accountId: z.string(),
    lineType: z.string(),
    lineObjectNumber: z.string(),
    description: z.string(),
    unitOfMeasureId: z.string(),
    unitOfMeasureCode: z.string(),
    unitPrice: z.number(),
    quantity: z.number(),
    discountAmount: z.number(),
    discountPercent: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    amountExcludingTax: z.number(),
    taxCode: z.string(),
    taxPercent: z.number(),
    totalTaxAmount: z.number(),
    amountIncludingTax: z.number(),
    invoiceDiscountAllocation: z.number(),
    netAmount: z.number(),
    netTaxAmount: z.number(),
    netAmountIncludingTax: z.number(),
    shipmentDate: z.string(),
    itemVariantId: z.string(),
    locationId: z.string(),
})
    .meta({ ref: "SalesInvoiceLine" });
export const SalesOrder = z
    .object({
    id: z.string(),
    number: z.string(),
    externalDocumentNumber: z.string(),
    orderDate: z.string(),
    postingDate: z.string(),
    customerId: z.string(),
    customerNumber: z.string(),
    customerName: z.string(),
    billToName: z.string(),
    billToCustomerId: z.string(),
    billToCustomerNumber: z.string(),
    shipToName: z.string(),
    shipToContact: z.string(),
    sellToAddressLine1: z.string(),
    sellToAddressLine2: z.string(),
    sellToCity: z.string(),
    sellToCountry: z.string(),
    sellToState: z.string(),
    sellToPostCode: z.string(),
    billToAddressLine1: z.string(),
    billToAddressLine2: z.string(),
    billToCity: z.string(),
    billToCountry: z.string(),
    billToState: z.string(),
    billToPostCode: z.string(),
    shipToAddressLine1: z.string(),
    shipToAddressLine2: z.string(),
    shipToCity: z.string(),
    shipToCountry: z.string(),
    shipToState: z.string(),
    shipToPostCode: z.string(),
    currencyId: z.string(),
    currencyCode: z.string(),
    paymentTermsId: z.string(),
    shipmentMethodId: z.string(),
    salesperson: z.string(),
    pricesIncludeTax: z.boolean(),
    discountAmount: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    totalAmountExcludingTax: z.number(),
    totalTaxAmount: z.number(),
    totalAmountIncludingTax: z.number(),
    status: z.string(),
    lastModifiedDateTime: z.string(),
    invoiceId: z.string(),
    invoiceNumber: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
})
    .meta({ ref: "SalesOrder" });
export const SalesOrderLine = z
    .object({
    id: z.string(),
    documentId: z.string(),
    sequence: z.number(),
    itemId: z.string(),
    accountId: z.string(),
    lineType: z.string(),
    lineObjectNumber: z.string(),
    description: z.string(),
    unitOfMeasureId: z.string(),
    unitOfMeasureCode: z.string(),
    quantity: z.number(),
    unitPrice: z.number(),
    discountAmount: z.number(),
    discountPercent: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    amountExcludingTax: z.number(),
    taxCode: z.string(),
    taxPercent: z.number(),
    totalTaxAmount: z.number(),
    amountIncludingTax: z.number(),
    invoiceDiscountAllocation: z.number(),
    netAmount: z.number(),
    netTaxAmount: z.number(),
    netAmountIncludingTax: z.number(),
    shipmentDate: z.string(),
    shippedQuantity: z.number(),
    invoicedQuantity: z.number(),
    invoiceQuantity: z.number(),
    shipQuantity: z.number(),
    itemVariantId: z.string(),
})
    .meta({ ref: "SalesOrderLine" });
export const PdfDocumentType = z
    .enum(["salesInvoices", "salesQuote", "salesCreditMemo", "purchaseInvoice"])
    .meta({ ref: "PdfDocumentType" });
export const OdataEtag = z.object({ "@odata.etag": z.string() });
export const OdataContext = z.object({ "@odata.context": z.string() });
export const WithOdataEtag = (zodType) => OdataEtag.merge(zodType);
export const WithOdataContext = (zodType) => OdataContext.merge(zodType);
export const ValueObject = (zodType) => z.object({
    value: zodType,
});
export const ListResponse = (zodType) => WithOdataContext(z.object({
    value: zodType.array(),
}));
export const ReadResponse = (zodType) => WithOdataContext(WithOdataEtag(zodType));
/**
 * Business Central Custom Entities
 */
export const CompanyCustom = z
    .object({
    id: z.string(),
    systemVersion: z.string(),
    timestamp: z.number(),
    name: z.string(),
    displayName: z.string(),
    businessProfileId: z.string(),
    systemCreatedAt: z.string(),
    systemCreatedBy: z.string(),
    systemModifiedAt: z.string(),
    systemModifiedBy: z.string(),
})
    .meta({ ref: "CompanyCustom" });
export const CustomerCustom = z
    .object({
    // UUID v4
    id: z.guid(),
    customerNo: z.string(),
    // Full name
    name: z.string(),
    formasjonPhoneNo: z.string(),
    formasjonCountryCodePhone: z.string(),
    birthDate: z.string(),
    email: z.string(),
    name2: z.string(),
    address: z.string(),
    // aka visitingAddress
    address2: z.string(),
    postCode: z.string(),
    city: z.string(),
    meterNumber: z.string(),
    // If the customer is active or not. Only when this is false, the customer is active.
    relocated: z.boolean(),
    departmentCode: z.string(),
    visitingPostCode: z.string(),
    visitingCity: z.string(),
})
    .meta({ ref: "CustomerCustom" });
export const GasPrice = z
    .object({
    // UUID v4
    id: z.guid(),
    // Corresponds to the departmentCode in the CustomerCustom entity
    Avdelingskode: z.string(),
    Avdelingsnavn: z.string(),
    Dato: z.string(),
    PrisPerKilo: z.number(),
    CO2avgift: z.number(),
    PrisPerKiloEksCO2: z.number(),
    VATAmount: z.number(),
    TotalInclVAT: z.number(),
})
    .meta({ ref: "GasPrice" });
export const MeterReading = z
    .object({
    id: z.string(),
    customerNo: z.string(),
    customerPhoneNo: z.string(),
    customerEmail: z.string(),
    date: z.string(),
    time: z.string(),
    method: z.enum(["WEB", "SMS", ""]),
    meterReading: z.number(),
    outgoingMessage: z.boolean(),
    outgoingText1: z.string(),
    outgoingText2: z.string(),
})
    .meta({ ref: "MeterReading" });
export const Consumption = z
    .object({
    id: z.string(),
    customerNo: z.string(),
    readingDate: z.string(),
    meterReading: z.number(),
    /**
     * If true, it is a smart reader
     */
    newMeter: z.boolean(),
    /**
     * If true, the reading is an estimate
     */
    estimate: z.boolean(),
})
    .meta({ ref: "Consumption" });
export const Interaction = z
    .object({
    entryNo: z.number(),
    canceled: z.boolean(),
    attemptFailed: z.boolean(),
    /**
     * Date of the interaction e.g. 2020-01-01
     */
    date: z.string(),
    /**
     * Time of the interaction e.g. 12:00:00
     */
    timeOfInteraction: z.string(),
    interactionTemplateCode: z.string(),
    /**
     * Description of the interaction template
     */
    description: z.string(),
    attachmentNo: z.number(),
    salespersonCode: z.string(),
    /**
     * Customer No to filter on
     */
    dnoCustomerNo: z.string(),
    comment: z.boolean(),
    /**
     * Title or subject of the message
     */
    formasjonDescription: z.string(),
    /**
     * Body of the message
     */
    formasjonDescription2: z.string(),
})
    .meta({ ref: "Interaction" });
export const SalesInvoiceCustom = z
    .object({
    id: z.string(),
    number: z.string(),
    externalDocumentNumber: z.string(),
    invoiceDate: z.string(),
    postingDate: z.string(),
    dueDate: z.string(),
    customerPurchaseOrderReference: z.string(),
    customerId: z.string(),
    customerNumber: z.string(),
    customerName: z.string(),
    billToName: z.string(),
    billToCustomerNumber: z.string(),
    shipToName: z.string(),
    shipToContact: z.string(),
    sellToAddressLine1: z.string(),
    sellToAddressLine2: z.string(),
    sellToCity: z.string(),
    sellToCountry: z.string(),
    sellToState: z.string(),
    sellToPostCode: z.string(),
    billToAddressLine1: z.string(),
    billToAddressLine2: z.string(),
    billToCity: z.string(),
    billToCountry: z.string(),
    billToState: z.string(),
    billToPostCode: z.string(),
    shipToAddressLine1: z.string(),
    shipToAddressLine2: z.string(),
    shipToCity: z.string(),
    shipToCountry: z.string(),
    shipToState: z.string(),
    shipToPostCode: z.string(),
    shortcutDimension1Code: z.string(),
    shortcutDimension2Code: z.string(),
    currencyCode: z.string(),
    orderNumber: z.string(),
    salesperson: z.string(),
    pricesIncludeTax: z.boolean(),
    remainingAmount: z.number(),
    discountAmount: z.number(),
    totalAmountExcludingTax: z.number(),
    totalAmountIncludingTax: z.number(),
    lastModifiedDateTime: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
    companyBankAccountNo: z.string(),
    KID: z.string(),
    CO2TAX: z.number(),
    consumption: z.number(),
})
    .meta({ ref: "SalesInvoiceCustom" });
export const SalesCreditMemoCustom = z
    .object({
    id: z.string(),
    number: z.string(),
    externalDocumentNumber: z.string(),
    creditMemoDate: z.string(),
    postingDate: z.string(),
    dueDate: z.string(),
    customerId: z.string(),
    customerNumber: z.string(),
    customerName: z.string(),
    billToName: z.string(),
    billToCustomerId: z.string(),
    billToCustomerNumber: z.string(),
    sellToAddressLine1: z.string(),
    sellToAddressLine2: z.string(),
    sellToCity: z.string(),
    sellToCountry: z.string(),
    sellToState: z.string(),
    sellToPostCode: z.string(),
    billToAddressLine1: z.string(),
    billToAddressLine2: z.string(),
    billToCity: z.string(),
    billToCountry: z.string(),
    billToState: z.string(),
    billToPostCode: z.string(),
    shortcutDimension1Code: z.string(),
    shortcutDimension2Code: z.string(),
    currencyId: z.string(),
    currencyCode: z.string(),
    paymentTermsId: z.string(),
    shipmentMethodId: z.string(),
    salesperson: z.string(),
    pricesIncludeTax: z.boolean(),
    discountAmount: z.number(),
    discountAppliedBeforeTax: z.boolean(),
    totalAmountExcludingTax: z.number(),
    totalTaxAmount: z.number(),
    totalAmountIncludingTax: z.number(),
    status: z.string(),
    lastModifiedDateTime: z.string(),
    invoiceNumber: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
    customerReturnReasonId: z.string(),
})
    .meta({ ref: "SalesCreditMemoCustom" });
export const ServiceReport = z
    .object({
    kundenummer: z.string(),
    dato: z.string(),
    SystemId: z.guid(),
    ecitid: z.number(),
    status: z.string(),
    utfort: z.string(),
    utfortAv: z.string(),
    pdfContent: z.string(),
})
    .meta({ ref: "ServiceReport" });
/**
 * Business Central Fetch Types
 */
export const LoginRequestBody = z.object({
    grant_type: z.string(),
    scope: z.string(),
    client_id: z.string(),
    client_secret: z.string(),
});
export const LoginResponseBody = z.object({
    token_type: z.literal("Bearer"),
    expires_in: z.number(),
    ext_expires_in: z.number(),
    access_token: z.string(),
});
export const ListCompaniesResponseBody = ListResponse(Company);
export const ListCompaniesCustomResponseBody = ListResponse(CompanyCustom);
export const ListCompanyCustomersResponseBody = ListResponse(Customer);
export const ListCompanyCustomersCustomResponseBody = ListResponse(CustomerCustom);
export const ReadCompanyCustomerResponseBody = ReadResponse(Customer);
export const ReadCompanyCustomerCustomResponseBody = ReadResponse(CustomerCustom);
export const ReadCompanyCustomerByEmailResponseBody = Customer.optional();
export const UpdateCompanyCustomerRequestBody = CustomerCustom.pick({
    formasjonPhoneNo: true,
    email: true,
}).partial();
export const UpdateCompanyCustomerResponseBody = ReadResponse(ReadCompanyCustomerResponseBody);
export const ListCompanyEmployeesResponseBody = ListResponse(Employee);
export const ReadCompanyEmployeeResponseBody = ReadResponse(Employee);
export const ReadCompanyEmployeeByEmailResponseBody = Employee.optional();
export const ListCompanySalesInvoicesResponseBody = ListResponse(SalesInvoice);
export const ReadCompanySalesInvoiceResponseBody = ReadResponse(SalesInvoice);
export const ListCompanySalesInvoicesCustomResponseBody = ListResponse(SalesInvoiceCustom);
export const ReadCompanySalesInvoiceCustomResponseBody = ReadResponse(SalesInvoiceCustom).extend({
    salesInvoiceLines: WithOdataEtag(SalesInvoiceLine),
});
export const ListCompanySalesInvoiceLinesResponseBody = ListResponse(SalesInvoiceLine);
export const ReadCompanySalesInvoicePdfDocumentResponseBody = ReadResponse(PdfDocument);
export const ReadCompanySalesInvoicePdfDocumentContentResponseBody = z.string();
export const ListCompanySalesCreditMemosResponseBody = ListResponse(SalesCreditMemo);
export const ReadCompanySalesCreditMemoResponseBody = ReadResponse(SalesCreditMemo);
export const ListCompanySalesCreditMemosCustomResponseBody = ListResponse(SalesCreditMemoCustom);
export const ReadCompanySalesCreditMemoCustomResponseBody = ReadResponse(SalesCreditMemoCustom).extend({
    salesCreditMemoLines: WithOdataEtag(SalesCreditMemoLine),
});
export const ListCompanySalesCreditMemoLinesResponseBody = ListResponse(SalesCreditMemoLine);
export const ReadCompanySalesCreditMemoPdfDocumentResponseBody = ReadResponse(PdfDocument);
export const ReadCompanySalesCreditMemoPdfDocumentContentResponseBody = z.string();
export const ListCompanyMeterReadingsResponseBody = ListResponse(MeterReading);
export const CreateCompanyMeterReadingRequestBody = MeterReading.partial().omit({ id: true });
export const CreateCompanyMeterReadingResponseBody = ReadResponse(MeterReading);
export const ListCompanyConsumptionsResponseBody = ListResponse(Consumption);
export const ListCompanyInteractionsResponseBody = ListResponse(Interaction);
export const ListCompanyGasPricesResponseBody = ListResponse(GasPrice);
export const ListCustomerServiceReportsResponseBody = ListResponse(ServiceReport);
export const ReadCustomerServiceReportResponseBody = ListResponse(ServiceReport);
// /**
//  * Business Central Fetch Types
//  */
// export type FetcherOptions<
//     R extends
//         BusinessCentralApiRequesterOptions = BusinessCentralApiRequesterOptions,
// > = {
//     options?: R;
// };
// export type WithFetcherOptions<T> = T & FetcherOptions;
// export type LoginOptions = WithFetcherOptions<{
//     body: LoginRequestBody;
// }>;
// export type ListCompaniesOptions = WithFetcherOptions<{
//     body: LoginRequestBody;
// }>;
// export type ListCompanyCustomersOptions = WithFetcherOptions<{
//     companyId?: string;
// }>;
// export type ReadCompanyCustomerOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId: string;
// }>;
// export type ReadCompanyCustomerCustomOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId: string;
// }>;
// export type ReadCompanyCustomerByEmailOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerEmail: string;
// }>;
// export type UpdateCompanyCustomerOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId: string;
//     body: UpdateCompanyCustomerRequestBody;
// }>;
// export type ListCompanyEmployeesOptions = WithFetcherOptions<{
//     companyId?: string;
// }>;
// export type ReadCompanyEmployeeOptions = WithFetcherOptions<{
//     companyId?: string;
//     employeeId: string;
// }>;
// export type ReadCompanyEmployeeByEmailOptions = WithFetcherOptions<{
//     companyId?: string;
//     employeeEmail: string;
// }>;
// export type ListCompanySalesInvoicesOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId?: string;
//     invoiceDateFrom?: string;
// }>;
// export type ReadCompanySalesInvoiceOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesInvoiceId: string;
// }>;
// export type ListCompanySalesInvoicesCustomOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId?: string;
//     invoiceDateFrom?: string;
// }>;
// export type ReadCompanySalesInvoiceCustomOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesInvoiceId: string;
// }>;
// export type ListCompanySalesInvoiceLinesOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesInvoiceId: string;
// }>;
// export type ReadCompanySalesInvoicePdfDocumentOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesInvoiceId: string;
// }>;
// export type ReadCompanySalesInvoicePdfDocumentContentOptions =
//     WithFetcherOptions<{
//         companyId?: string;
//         salesInvoiceId: string;
//     }>;
// export type ListCompanySalesCreditMemosOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId?: string;
//     invoiceDateFrom?: string;
// }>;
// export type ReadCompanySalesCreditMemoOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesCreditMemoId: string;
// }>;
// export type ListCompanySalesCreditMemosCustomOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerId?: string;
//     invoiceDateFrom?: string;
// }>;
// export type ReadCompanySalesCreditMemoCustomOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesCreditMemoId: string;
// }>;
// export type ListCompanySalesCreditMemoLinesOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesCreditMemoId: string;
// }>;
// export type ReadCompanySalesCreditMemoPdfDocumentOptions = WithFetcherOptions<{
//     companyId?: string;
//     salesCreditMemoId: string;
// }>;
// export type ReadCompanySalesCreditMemoPdfDocumentContentOptions =
//     WithFetcherOptions<{
//         companyId?: string;
//         salesCreditMemoId: string;
//     }>;
// export type ListCompanyMeterReadingsOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerNo: string;
//     dateFrom: string;
//     dateTo: string;
// }>;
// export type CreateCompanyMeterReadingOptions = WithFetcherOptions<{
//     companyId?: string;
//     body: CreateCompanyMeterReadingRequestBody;
// }>;
// export type ListCompanyConsumptionsOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerNo: string;
//     dateFrom: string;
//     dateTo: string;
// }>;
// export type ListCompanyInteractionsOptions = WithFetcherOptions<{
//     companyId?: string;
//     customerNo: string;
//     dateFrom: string;
//     dateTo: string;
// }>;
// export type ListCompanyGasPricesOptions = WithFetcherOptions<{
//     companyId?: string;
//     Avdelingskode: string;
//     dateFrom: string;
//     dateTo: string;
// }>;
// export type ListCustomerServiceReportsOptions = WithFetcherOptions<{
//     companyId?: string;
//     Kundenummer: string;
//     pagination?: RequestPagination;
// }>;
// export type ReadCustomerServiceReportOptions = WithFetcherOptions<{
//     companyId?: string;
//     SystemId: string;
// }>;
/**
 * Business Central API
 */
// export interface BusinessCentralApiRequesterOptions
//     extends ApiBaseRequesterOptions {
//     /** Defaults to 'api' */
//     useUrl?: "auth" | "api" | "customApi" | "dataProApi";
// }
// export interface BusinessCentralApiConstructorOptions
//     extends ApiBaseConstructorOptions {
//     urlAuth: string;
//     urlApi: string;
//     urlCustomApi: string;
//     urlDataProApi: string;
//     clientId: string;
//     clientSecret: string;
//     companyId: string;
// }
